import { Label as LabelPrimitive } from 'radix-ui'
import type * as React from 'react'

import { cn } from '@/utils/utils'

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
	return (
		<LabelPrimitive.Root
			data-slot='label'
			className={cn(
				// `leading-4` matches the 16px icons a label sits beside (a field's hint, a checkbox), so a
				// row keeps one height whether or not it has one — `leading-none` would size the text box to
				// 14px and drop the field's input 2px on the rows without.
				'flex items-center gap-2 text-sm leading-4 font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
				className,
			)}
			{...props}
		/>
	)
}

export { Label }
